/* src/app/modules/user/partnersequity/partnersequity.component.css */
/*# sourceMappingURL=partnersequity.component.css.map */
